/**
 * @file 获取完成/未完成的学员
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

 import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface ICompletionListInput {
    task_id: number; // int，
    type: number; // int，查看类别 1：已完成；2：未完成
    page: number; // int，页码
    size: number; // int，每页数量
}

export interface ICompletionListOutput {
    list: ICompletionItemInfo[];
    stat: {
        complete_num: number;
        uncomplete_num: number;
    };
}

export const getCompletionList = (data: ICompletionListInput): Promise<ICompletionListOutput> => {
    return fetchData(Api.CLASS_TASK_COMPLETION_LIST, data).then((res: IResponse<ICompletionListOutput>) => {
        return res.data as ICompletionListOutput;
    });
};
